export const complaints = {
    heading: 'complaints-page-heading',
    sectionHeading: 'complaints-section-heading',
    sectionBody: 'complaints-section-body',
  };
  